<bw-bui-tile-legacy tileMargin="0 0 8px 0">
  <bui-tile-card-legacy
    [cardBorder]="'1px solid var(--border)'"
    [cardBackground]="cardConfig[cardInfo.state].backgroundColor">
    <bw-bui-row-legacy [rightIconName]="cardConfig[cardInfo.state].iconName"
                [rightIconColor]="cardConfig[cardInfo.state].iconColor">
      <div class="row-content">
        <bw-bui-column-legacy
          [rowSpacing]="4"
          [rows]="[
                  { type: 'heading', content: cardInfo.title | uppercase | translate, color: 'var(--black)' }
                ]"
        ></bw-bui-column-legacy>
      </div>
    </bw-bui-row-legacy>
  </bui-tile-card-legacy>
</bw-bui-tile-legacy>
